// @flow
import JQueryView, { on } from '../../common/JQueryView';
import {
  RESOLUTION_OTHER_CATEGORY,
  RESOLUTION_CLASS_STOCK_CATEGORY,
} from '../../../models/ResolutionCategory';

declare var $: any;

export default class ReportView extends JQueryView {
  isAttachedConvocationNotice: boolean;

  constructor(isAttachedConvocationNotice: boolean) {
    super('.company.director_meetings.report');
    this.isAttachedConvocationNotice = isAttachedConvocationNotice;
    this.render();
  }

  @on({ event: 'click', selector: '.reports_form .remove_fields' })
  onClickReportRemoveFields(event: any) {
    event.preventDefault();
    this.removeFields(event.target);
    this.assignReportsSequence();
    this.updatePreview();
  }

  @on({ event: 'click', selector: '.resolutions_form .remove_fields' })
  onClickResolutionRemoveFields(event: any) {
    event.preventDefault();
    this.removeFields(event.target);
    this.assignResolutionsSequence();
    this.updatePreview();
  }

  @on({ event: 'click', selector: '.minute_papers_form .remove_fields' })
  onClickMinutePaperRemoveFields(event: any) {
    event.preventDefault();
    this.removeFields(event.target);
  }

  @on({ event: 'click', selector: '.reports_form .add_fields' })
  onClickReportAddFields(event: any) {
    event.preventDefault();
    this.addFields(event.target);
    this.assignReportsSequence();
    this.render();
    this.updatePreview();
  }

  @on({ event: 'click', selector: '.resolutions_form .add_fields' })
  onClickResolutionAddFields(event: any) {
    event.preventDefault();
    this.addFields(event.target);
    this.assignResolutionsSequence();
    this.render();
    this.updatePreview();
  }

  @on({ event: 'click', selector: '.minute_papers_form .add_fields' })
  onClickMinutePaperAddFields(event: any) {
    event.preventDefault();
    this.addFields(event.target);
  }

  @on({ event: 'click', selector: '#js-exchange' })
  onClickExchangeFields(event: any) {
    const target = $('#officer_approval_director_meeting_agenda_order');
    event.preventDefault();
    $('#js-exchange_agenda')
      .toggleClass('flex-column-reverse')
      .toggleClass('flex-column');
    target.val() == 1 ? target.val(0) : target.val(1);
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.report_other' })
  onChangeReportOther() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.report-content' })
  onChangeReportContent() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.resolution_other' })
  onChangeResolutionOther() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.resolution-content' })
  onChangeResolutionContent() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.resolution_select' })
  onChangeResolutionSelect(event: any) {
    this.showResolutionForm($(event.target));
    this.updatePreview();
  }

  @on({
    event: 'change',
    selector: '.officer_approval_director_meeting_resolutions_stock_type_id',
  })
  onChangeResolutionStockTypeSelect(event: any) {
    this.showResolutionForm($(event.target));
    this.updatePreview();
  }

  addFields(target: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(target).data('id'), 'g');
    $(target).before(
      $(target)
        .data('fields')
        .replace(regexp, time),
    );
  }

  removeFields(target: any) {
    $(target)
      .prev('input[type=hidden]')
      .val('1');
    $(target)
      .closest('fieldset')
      .hide();
  }

  assignReportsSequence() {
    $('fieldset.report:visible').each((index, element) => {
      $(element)
        .find('.sequence')
        .val(index + 1);
    });
  }

  assignResolutionsSequence() {
    $('fieldset.resolution:visible').each((index, element) => {
      $(element)
        .find('.sequence')
        .val(index + 1);
    });
  }

  showResolutionForm(select: any) {
    const select_val = Number(select.val());
    const stockTypeForm = select.parent().next();
    const otherForm = stockTypeForm.next();

    if (RESOLUTION_CLASS_STOCK_CATEGORY.includes(select_val)) {
      stockTypeForm.show();
      otherForm.hide();
    } else if (RESOLUTION_OTHER_CATEGORY.includes(select_val)) {
      otherForm.show();
      stockTypeForm.hide();
    } else {
      otherForm.hide();
      stockTypeForm.hide();
    }
  }

  hideReportField() {
    let reportSize = $('.report_other').length;
    if (reportSize == 1) {
      $('#reports').hide();
    }
    let resolutionSize = $('.resolution_other').length;
    if (resolutionSize == 1) {
      $('#resolutions').hide();
    }
  }

  updatePreview() {
    if (this.isAttachedConvocationNotice) {
      $('.simple_form').attr('data-remote', 'true');
      $('#preview_button').click();
      $('.simple_form').attr('data-remote', 'false');
    }
  }

  initAdjustReportTextArea = (): void => {
    const targets = $('.report-content, .resolution-content');
    if (targets.length) {
      for (let i = 0; i < targets.length; i++) {
        targets[i].style.height = 'auto';
        targets[i].style.height = targets[i].scrollHeight + 'px';
      }
    }
  };

  initAdjustResolutionTextArea = () => {
    const targets = $('.report-content, .resolution-content');
    if (targets.length) {
      for (let i = 0; i < targets.length; i++) {
        targets[i].style.height = 'auto';
        targets[i].style.height = targets[i].scrollHeight + 'px';
      }
    }
  };

  render() {
    $('.resolution_select').each((i, a) => {
      this.showResolutionForm($(a));
    });
    $('.report-content, .resolution-content').on('input', function() {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });
    this.initAdjustReportTextArea();
    this.initAdjustResolutionTextArea();
    this.assignReportsSequence();
    this.assignResolutionsSequence();
  }
}
